<template>
  <div class="fields__fields" v-if="enabled">
    <ElTooltip
      v-for="(input, index) in inputTypes"
      class="item"
      effect="dark"
      :content="input.typeName"
      placement="left"
      :key="input.id">
      <div
        :class="{
          'fields__field': true,
          'fields__field--selected': input.type === selected.type
          }"
        :data-type="input.type"
        :key="index"
        :data-ec="ec"
        :data-et="`select_field_${input.type}`"
        @click="selectFromList(input)">
          <FontIcon :name="input.icon" height="18" width="18" />
      </div>
    </ElTooltip>
  </div>
</template>

<script>
import FontIcon from '@/components/Icon.vue';

export default {
  components: {
    FontIcon,
  },
  props: {
    ec: String,
    enabled: Boolean,
    selected: Object,
    inputTypes: Array,
  },
  data() {
    return {};
  },
  methods: {
    selectFromList(selected) {
      this.$emit('select', selected);
    },
  },
};
</script>

<style scoped>
.fields__fields {
  padding: var(--spacing-base);
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  flex-basis: 88px;
  /* TODO Refactor to remove these hardcoded values */
  min-width: 82px;
  border-bottom-right-radius: 3px;
}

.fields__field {
  color: #fff;
  background: var(--signable-secondary-2);
  border: 2px solid #253843;
  height: 52px;
  width: 52px;
  border-radius: 30px;
  position: relative;
  margin: 0 auto var(--spacing-base);
  cursor: pointer;
  transition: transform .05s ease;
  z-index: 0;
  position: relative;
}

.fields__field:hover {
  z-index: 3;
}

.fields__field:hover, .fields__field--selected {
  transform: scale(1.2);
}

.fields__field[data-type="text"] {
  background-color: var(--color-text-field);
  border: 2px solid #c29d0b;
}

.fields__field[data-type="signature"] {
  background-color: var(--color-signature-field);
  border: 2px solid #107360;
}

.fields__field[data-type="date"] {
  background-color: var(--color-date-field);
  border: 2px solid #804399;
}

.fields__field[data-type="dropdown"] {
  background-color: var(--color-dropdown-field);
  border: 2px solid #667273;
}

.fields__field[data-type="checkbox"] {
  background-color: var(--color-checkbox-field);
  border: 2px solid #962d22;
}

.fields__field[data-type="upload"] {
  background-color: var(--color-upload-field);
  border: 2px solid #bf6516;
}

.fields__field[data-type="cancel"] {
  background-color: var(--color-error-dark);
  border: 2px solid #bf2718;
}

.fields__field[data-type="send"] {
  background-color: var(--color-success-dark);
  border: 2px solid #19703e;
}

.fields__field svg,
.fields__field span {
  pointer-events: none;
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
}

.fields__field span {
  font-weight: bold;
}

.fields__field {
  color: #fff;
}

.fields__field__separator {
  border-top: 1px solid var(--color-border);
  margin-bottom: var(--spacing-base);
}

</style>
